import { useMemo } from "react";
import { Flex, Button, Text, useColorMode } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import NavigationButtons from "src/components/NavigationButtons";
import { H3, Subtitle } from "src/atoms/typography";
import { SceneLayout } from "src/components/SceneLayout";
import FullScreen from "src/atoms/FullScreen";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Ios } from "./icons/light-ios.svg";
import { ReactComponent as Android } from "./icons/light-android.svg";
import { ReactComponent as Desktop } from "./icons/light-desktop.svg";
import { ReactComponent as Arrow } from "./icons/arrow_light.svg";
import SvgContainer from "src/components/SvgContainer";

function HowItWorks() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { colorMode } = useColorMode();
  const isDarkMode = colorMode === "dark";

  const devicesEnum = useMemo(
    () => [
      {
        stringKey: "howToInstall.device.ios",
        icon: Ios,
        id: "ios",
        iconFill: "mediumEmphasis"
      },
      {
        stringKey: "howToInstall.device.android",
        icon: Android,
        id: "android",
        iconFill: isDarkMode ? "#409100" : "#58a509"
      },
      {
        stringKey: "howToInstall.device.desktop",
        icon: Desktop,
        id: "desktop",
        iconFill: "tint3"
      }
    ],
    [isDarkMode]
  );

  return (
    <>
      <NavigationButtons
        mode="fullScreen"
        onBack={() => navigate("/welcome")}
      />
      <FullScreen>
        <SceneLayout
          centerProps={{ pb: "20px", width: "320px" }}
          center={
            <>
              <H3 mt="8px" textAlign="center" color="highEmphasis" mb="16px">
                {t("pairing.help.deviceSelect.title")}
              </H3>
              <Flex flexDir="column" rowGap="16px">
                {devicesEnum.map(({ icon, id, stringKey, iconFill }) => (
                  <Button
                    variant="custom"
                    display="flex"
                    key={id}
                    py="24px"
                    pl="16px"
                    pr="12px"
                    borderRadius="16px"
                    bg="surfaceElevated1"
                    color="mediumEmphasis"
                    boxShadow="0px 2px 5px 0px rgba(0, 0, 0, 0.12), 0px 1px 19px 0px rgba(0, 0, 0, 0.06), 0px 5px 10px 0px rgba(0, 0, 0, 0.08)"
                    _hover={{ bg: "hover" }}
                    _active={{ bg: "iconBackground" }}
                    alignItems="center"
                    onClick={() =>
                      navigate(`/device-install/${id}
                    `)
                    }
                  >
                    <SvgContainer icon={icon} fill={iconFill} />
                    <Subtitle flexGrow="1" mx="10px" textAlign="start">
                      {t(stringKey)}
                    </Subtitle>
                    <SvgContainer icon={Arrow} fill="lowEmphasis" />
                  </Button>
                ))}
              </Flex>
            </>
          }
        />
      </FullScreen>
    </>
  );
}

export default HowItWorks;
